import { render, staticRenderFns } from "./UpdateRight.vue?vue&type=template&id=0c16cc54&scoped=true&"
import script from "./UpdateRight.vue?vue&type=script&lang=js&"
export * from "./UpdateRight.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRight.vue?vue&type=style&index=0&id=0c16cc54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c16cc54",
  null
  
)

export default component.exports